// API Endpoints Constants
export const API_ENDPOINTS = {
    // Account Management
    GET_CURRENT_USER: '/getCurrentUser',
    UPDATE_ACCOUNT_DETAILS_ACTION: '/updateAccountDetailsAction',
    CHANGE_MY_PASSWORD: '/changeMyPassword',
    RESET_PASSWORD: '/resetMyPasswordAction',
    FORGOT_PASSWORD: '/forgotPasswordAction',
    VIEW_ACCOUNT_DETAILS: '/viewAccountDetails',
    UPDATE_ACCOUNT_DETAILS: '/updateAccountDetails',

    // Company Management
    GET_ALL_COMPANIES: '/getAllCompanies',
    SEARCH_COMPANIES: '/searchCompanies',
    LIST_COMPANIES: '/listCompanies',
    DISPLAY_COMPANY: '/displayCompany',
    DELETE_COMPANY: '/deleteCompany',
    SAVE_COMPANY: '/saveCompany',
    MODIFY_COMPANY_ACTION: '/modifyCompanyAction',
    MODIFY_COMPANY_CONFIG: '/modifyCompanyConfig',
    MODIFY_COMPANY_CONFIG_ACTION: '/modifyCompanyConfigAction',

    // User Management
    LIST_USERS: '/listUsers',
    SEARCH_USERS: '/searchUsers',
    DISPLAY_USER: '/displayUser',
    DELETE_USER: '/deleteUser',
    SEND_ESS_INVITE_TO_EMP: '/sendESSInviteToEmp',
    CREATE_USER: '/createUser',
    MODIFY_USER: '/modifyUser',
    SAVE_USER: '/saveUser',
    MODIFY_USER_ACTION: '/modifyUserAction',
    BULK_UPLOAD_USERS: '/bulkUploadUsers',
    BULK_UPLOAD_USERS_TEMPLATE: '/downloadUserBulkUploadTemplate',

    // Location Management
    SEARCH_LOCATION_ACTION: '/searchLocationAction',
    LOCATIONS: '/locations',
    NEW_LOCATION: '/newLocation',
    MODIFY_LOCATION: '/modifyLocation',
    NEW_LOCATION_ACTION: '/newLocationAction',
    MODIFY_LOCATION_ACTION: '/modifyLocationAction',
    DELETE_LOCATION: '/deleteLocation',
    VIEW_LOCATION: '/viewLocation',

    // Department Management
    SEARCH_DEPARTMENT_ACTION: '/searchDepartmentAction',
    DEPARTMENTS: '/departments',
    NEW_DEPARTMENT: '/newDepartment',
    MODIFY_DEPARTMENT: '/modifyDepartment',
    NEW_DEPARTMENT_ACTION: '/newDepartmentAction',
    BULK_NEW_DEPARTMENT_ACTION: '/bulkNewDepartmentAction',
    MODIFY_DEPARTMENT_ACTION: '/modifyDepartmentAction',
    DELETE_DEPARTMENT: '/deleteDepartment',
    VIEW_DEPARTMENT: '/viewDepartment',

    // Designation Management
    SEARCH_DESIGNATION_ACTION: '/searchDesignationAction',
    DESIGNATIONS: '/designations',
    NEW_DESIGNATION: '/newDesignation',
    MODIFY_DESIGNATION: '/modifyDesignation',
    NEW_DESIGNATION_ACTION: '/newDesignationAction',
    BULK_NEW_DESIGNATION_ACTION: '/bulkNewDesignationAction',
    MODIFY_DESIGNATION_ACTION: '/modifyDesignationAction',
    DELETE_DESIGNATION: '/deleteDesignation',
    VIEW_DESIGNATION: '/viewDesignation',

    // Role Management
    SEARCH_ROLE: '/searchRole',
    LIST_ROLES: '/listRoles',
    CREATE_ROLE: '/createRole',
    MODIFY_ROLE: '/modifyRole',
    SAVE_ROLE: '/saveRole',
    MODIFY_ROLE_ACTION: '/modifyRoleAction',
    DELETE_ROLE: '/deleteRole',
    VIEW_ROLE: '/viewRole',

    // Position Management
    LIST_POSITIONS: '/listPositions',
    SEARCH_POSITIONS: '/searchPositions',
    STATUS_BY_POSITION_COUNT: '/statusByPositionCount',
    PRE_CREATE_POSITION: '/preCreatePosition',
    CREATE_POSITION: '/createPosition',
    CREATE_POSITION_WITH_COMPA_FIELDS: '/createPositionWithCompaFields',
    PRE_MODIFY_POSITION: '/preModifyPosition',
    PRE_MODIFY_POSITION_WITH_COMPA_FIELDS: '/preModifyPositionWithCompaFields',
    MODIFY_POSITION: '/modifyPosition',
    MODIFY_POSITION_WITH_COMPA_FIELDS: '/modifyPositionWithCompaFields',
    DISPLAY_POSITION: '/displayPosition',
    POSITION_DETAILS: '/positionDetails',
    POSITION_DETAILS_WITH_COMPA_FIELDS: '/positionDetailsWithCompaFields',
    BULK_UPDATE_POSITION_STATUSES: '/bulkUpdatePositionStatuses',
    UPDATE_SINGLE_POSITION_STATUS: '/updateSinglePositionStatus',
    UPDATE_POSITIONS_MAPPED_TO_CHANGE_REQUEST_POLICY: '/updatePositionsMappedToChangeRequestPolicy',
    UPDATE_POSITIONS_MAPPED_TO_RECRUITMENT_POLICY: '/updateMappedPositionsToRecruitmentPolicy',
    RESYNC_POSITION: '/resyncPosition',
    SCHEDULE_INTAKE: '/scheduleIntake',
    COMPLETE_INTAKE: '/completeIntake',
    UPDATE_POSITION_START_DATE: '/updatePositionStartDate',
    POSITION_STATUS_HISTORY: '/positionStatusHistory',
    LOAD_POSITION_DATA_ACTION: '/loadPositionDataAction',
    UPDATE_EXTERNAL_ENTITY_ID: '/updateExternalEntityId',
    EXPORT_POSITION_DATA: '/exportPositionData',
    EXPORT_POSITION_DATA_WITH_COMPA_FIELDS: '/exportPositionDataWithCompaFields',
    DOWNLOAD_POSITION_DATA_TEMPLATE: '/downloadPositionDataTemplate',
    DOWNLOAD_POSITION_DATA_TEMPLATE_WITH_COMPA_FIELDS: '/downloadPositionDataTemplateWithCompaFields',

    // Change Request Management
    LIST_CHANGE_REQUESTS: '/listChangeRequests',
    SEARCH_CHANGE_REQUESTS_ACTION: '/searchChangeRequestsAction',
    BULK_UPDATE_CHANGE_REQUEST_STATUSES: '/bulkUpdateChangeRequestStatuses',
    ACTION_CHANGE_REQUEST: '/actionChangeRequest',
    CANCEL_ACTIVE_CHANGE_REQUEST: '/cancelActiveChangeRequest',
    DELETE_CHANGE_REQUEST: '/deleteChangeRequest',
    PRE_CREATE_CHANGE_REQUEST: '/preCreateChangeRequest',
    PRE_CREATE_CHANGE_REQUEST_WITH_COMPA_FIELDS: '/preCreateChangeRequestWithCompaFields',
    PRE_CREATE_BULK_CHANGE_REQUEST: '/preCreateBulkChangeRequestBulk',
    PRE_CREATE_BULK_CHANGE_REQUEST_WITH_COMPA_FIELDS: '/preCreateChangeRequestsWithCompaFieldsBulk',
    CREATE_CHANGE_REQUEST: '/createChangeRequest',
    CREATE_CHANGE_REQUEST_WITH_COMPA_FIELDS: '/createChangeRequestWithCompaFields',
    CREATE_BULK_CHANGE_REQUEST: '/createChangeRequestsBulk',
    CREATE_BULK_CHANGE_REQUEST_WITH_COMPA_FIELDS: '/createChangeRequestsWithCompaFieldsBulk',
    PRE_MODIFY_CHANGE_REQUEST: '/preModifyChangeRequest',
    PRE_MODIFY_CHANGE_REQUEST_WITH_COMPA_FIELDS: '/preModifyChangeRequestWithCompaFields',
    MODIFY_CHANGE_REQUEST: '/modifyChangeRequest',
    MODIFY_CHANGE_REQUEST_WITH_COMPA_FIELDS: '/modifyChangeRequestWithCompaFields',
    DISPLAY_CHANGE_REQUEST: '/displayChangeRequest',
    DISPLAY_CHANGE_REQUEST_WITH_COMPA_FIELDS: '/displayChangeRequestWithCompaFields',

    // Change Request Policy Roles
    PRE_CREATE_ROLES_MAPPING_TO_CHANGE_REQUEST_POLICY: '/preCreateRolesMappingToChangeRequestPolicy',
    SAVE_ROLES_MAPPED_TO_CHANGE_REQUEST_POLICY: '/saveRolesMappedToChangeRequestPolicy',

    // Change Request Policies
    LIST_CHANGE_REQUEST_POLICIES: '/listChangeRequestPolicies',
    SEARCH_CHANGE_REQUEST_POLICIES_ACTION: '/searchChangeRequestPoliciesAction',
    CREATE_CHANGE_REQUEST_POLICY: '/createChangeRequestPolicy',
    DELETE_CHANGE_REQUEST_POLICY: '/deleteChangeRequestPolicy',
    PRE_CREATE_CHANGE_REQUEST_POLICY: '/preCreateChangeRequestPolicy',
    PRE_MODIFY_CHANGE_REQUEST_POLICY: '/preModifyChangeRequestPolicy',
    DISPLAY_CHANGE_REQUEST_POLICY: '/displayChangeRequestPolicy',
    MODIFY_CHANGE_REQUEST_POLICY: '/modifyChangeRequestPolicy',

    // Master Attributes Management
    SEARCH_MASTER_CUSTOM_ATTRIBUTES: '/searchMasterCustomAttributes',
    GET_MASTER_CUSTOM_ATTRIBUTES: '/getMasterCustomAttributes',
    CREATE_MASTER_CUSTOM_ATTRIBUTE: '/createMasterCustomAttribute',
    UPDATE_MASTER_CUSTOM_ATTRIBUTE: '/updateMasterCustomAttribute',
    DELETE_MASTER_CUSTOM_ATTRIBUTE: '/deleteMasterCustomAttribute',
    GET_AUDIT_LOGS: '/getAuditLogs',
    EXPORT_AUDIT_LOGS: '/exportAuditLogs',

    // Demand Attributes Management
    VIEW_META_OBJECT_DEFINITION: '/viewMetaObjectDefinition',
    LIST_META_OBJECT_DEFINITIONS: '/listMetaObjectDefinitions',
    SAVE_META_OBJECT_DEFINITION: '/saveMetaObjectDefinition',
    MODIFY_META_OBJECT_DEFINITION_ACTION: '/modifyMetaObjectDefinitionAction',
    DELETE_META_OBJECT_DEFINITION: '/deleteMetaObjectDefinition',

    // Recruitment Policy Management
    FETCH_RECRUITMENT_POLICY: '/fetchRecruitmentPolicy',
    RESYNC_ALL_POSITIONS_WITH_ALL_POLICIES: '/resyncAllPositionsWithAllPolicies',
    RESYNC_SINGLE_RECRUITMENT_POLICY: '/resyncSingleRecruitmentPolicy',
    SAVE_RULES_FOR_RECRUITMENT_POLICY: '/saveRulesForRecruitmentPolicy',
    DELETE_RULES_FOR_RECRUITMENT_POLICY: '/deleteRulesForRecruitmentPolicy',
    PRE_CREATE_RULES_FOR_RECRUITMENT_POLICY: '/preCreateRulesForRecruitmentPolicy',
    PRE_CREATE_RULE_SETTINGS_FOR_RECRUITMENT_POLICY: '/preCreateRuleSettingsForRecruitmentPolicy',
    SAVE_RULE_SETTING_FOR_RECRUITMENT_POLICY: '/saveRuleSettingForRecruitmentPolicy',

    // Common/Settings Management
    RESET_SYSTEM_REQUEST_MAPS_ACTION: '/resetSystemRequestMapsAction',
    LOAD_INTEGRATION_CONFIGURATION: '/loadIntegrationConfiguration',
    RESET_SYSTEM_PERMISSIONS_ACTION: '/resetSystemPermissionsAction',

    // Download Management
    DOWNLOAD_POSITION_EXTERNAL_ID_TEMPLATE: '/downloadPositionExternalIdTemplate',
    DOWNLOAD_ATTACHMENTS_FOR_CHANGE_REQUEST: '/downloadAttachmentsForChangeRequest',

    // Login Management
    LOGIN: '/login',
    LOGOUT: '/logout',

    // Dashboard Management
    POSITION_SUMMARY_BY_STATUS: '/positionSummaryByStatus',
    CR_SUMMARY_BY_STATUS: '/changeRequestSummaryByStatus',
    POSITION_MAPPING_SUMMARY_BY_STATUS: '/positionMappingSummaryByStatus',
    POSITION_RECRUITMENT_POLICY_MAPPING_SUMMARY: '/fetchRecruitmentPolicySummary',
    POSITION_CLOSURE_SUMMARY_BY_STATUS: '/positionClosureSummary',
    GET_POSITIONS_MAPPED_TO_CHANGE_REQUEST_POLICY: '/getPositionsMappedToChangeRequestPolicy',

    // PreHQ Management
    LIST_PRE_HIRING_POSITIONS: '/listPreHiringPositions',
    GET_PRE_HIRING_POSITION: '/getPreHiringPosition',
    ADD_PRE_HIRING_POSITION_COMMENT: '/addPreHiringPositionComment',
    UPDATE_PRE_HIRING_POSITION: '/updatePreHiringPosition',
    CREATE_PRE_HIRING_POSITION: '/createPreHiringPosition',
    SAVE_POSITION_DRAFT: '/savePositionDraft',
    DEPLOY_POSITION: '/deployPosition',
    GET_POSITION_DRAFT: '/getPositionDraft',
    UPDATE_POSITION_DRAFT: '/updatePositionDraft',
    COMPANY_LOCATIONS_EMPLOYEES: '/companyLocationsEmployees',
    JOB_AUTOCOMPLETE: '/jobAutocomplete',
    MATCH_SKILLS_TO_ROLES: '/matchSkillsToRoles',
    GENERATE_JOB_DESCRIPTIONS: '/generateJobDescriptions',
    UPDATE_JOB_DESCRIPTION: '/updateJobDescription',
    FETCH_PRE_HIRING_JOB_DESCRIPTION: '/fetchPreHiringJobDescription',
    PRE_DRAFT_APPROVE_PRE_HIRING_POSITION: '/preEditPostApprovePreHiringPosition',
    BULK_UPLOAD_TEMPLATE: '/downloadPreHiringPositionTemplate',
    BULK_UPLOAD_POSITIONS: '/bulkUploadPreHiringPositions',
    BULK_EDIT_POSITIONS: '/bulkUpdatePreHiringPositions',
    BULK_EDIT_TEMPLATE: '/downloadPreHiringPositionBulkUpdateTemplate',
    // Change Request Policy Roles
    PRE_HQ_PRE_CREATE_ROLES_MAPPING_TO_CHANGE_REQUEST_POLICY: '/preCreateRolesMappingToPreHqReviewPolicy',
    PRE_HQ_SAVE_ROLES_MAPPED_TO_CHANGE_REQUEST_POLICY: '/saveRolesMappedToPreHqReviewPolicy',
    // Change Request Policy Policy
    PRE_HQ_PRE_CREATE_REVIEW_POLICY: '/preCreateReviewPolicy',
    PRE_HQ_CREATE_REVIEW_POLICY: '/createReviewPolicy',
    PRE_HQ_PRE_MODIFY_REVIEW_POLICY: '/preModifyReviewPolicy',
    PRE_HQ_MODIFY_REVIEW_POLICY: '/modifyReviewPolicy',
    PRE_HQ_LIST_REVIEW_POLICIES: '/listReviewPolicies',
    PRE_HQ_DISPLAY_REVIEW_POLICY: '/displayReviewPolicy',
    PRE_HQ_UPDATE_POSITIONS_MAPPED_TO_REVIEW_POLICY: '/updatePositionsMappedToReviewPolicy',
    PRE_HQ_DELETE_REVIEW_POLICY: '/deleteReviewPolicy',
    PRE_HQ_BULK_APPROVE_POSITIONS: '/createPositionsFromPreHiringPositions',
};
